/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Copy_Plan_SuccessInputs */



/**
* | output |
* | --- |
* | "Plan copied successfully" |
*
* @param {Intervention_Plan_Copy_Plan_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_copy_plan_success = /** @type {((inputs?: Intervention_Plan_Copy_Plan_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Copy_Plan_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Plan copied successfully")
	return /** @type {LocalizedString} */ ("Le plan a été copié avec succès")
});